import { useMutation, useQueryClient } from "@tanstack/react-query";
import * as Sentry from "@sentry/react";
import toast from "react-hot-toast";
import { supabase } from "../../lib/supabase";
import { queryKeys } from "../../lib/queryKeys";
import { useAuth } from "../../contexts/AuthContext";
import { Tag, NewTag } from "../../types";

export function useCreateTag() {
  const queryClient = useQueryClient();
  const { user } = useAuth();

  return useMutation({
    mutationFn: async (newTag: NewTag): Promise<Tag> => {
      if (!user) throw new Error("Not authenticated");
      const { data, error } = await supabase
        .from("tags")
        .insert({ user_id: user.id, name: newTag.name, color: newTag.color })
        .select()
        .single();
      if (error) throw error;
      return data as Tag;
    },

    onSuccess: (created) => {
      queryClient.setQueryData<Tag[]>(queryKeys.tags, (old) => [
        ...(old ?? []),
        created,
      ]);
    },

    onError: (err) => {
      Sentry.captureException(err, { extra: { mutation: "useCreateTag" } });
      toast.error("Failed to create tag. Please try again.");
    },
  });
}
